import { TestingUploadResultsAction } from '@/features/shared/components/TestingUploadResultsAction';
import type { ReactElement } from 'react';

type ExecutionRunsUploadActionProps = {
  disabledReason: string | null;
  onClick: () => void;
};

const ExecutionRunsUploadAction = ({
  disabledReason,
  onClick,
}: ExecutionRunsUploadActionProps): ReactElement => {
  return <TestingUploadResultsAction disabledReason={disabledReason} onClick={onClick} />;
};

export { ExecutionRunsUploadAction };
